import { createFileRoute } from "@tanstack/react-router";

import { OrderDetailPage } from "@/features/orders";

interface OrderDetailSearch {
  /** Raw orders.id of a specific sibling package to force-fetch, set by a RelatedOrdersBanner link. */
  order_id?: string;
}

export const Route = createFileRoute("/_authenticated/orders_/$saleOrderId")({
  validateSearch: (raw: Record<string, unknown>): OrderDetailSearch => ({
    ...(typeof raw.order_id === "string" && raw.order_id !== "" && { order_id: raw.order_id }),
  }),
  component: function OrderDetailRoute() {
    const { saleOrderId } = Route.useParams();
    const { order_id } = Route.useSearch();
    return (
      <OrderDetailPage
        saleOrderId={saleOrderId}
        {...(order_id !== undefined && { orderId: order_id })}
      />
    );
  },
});
